import type { Entity } from '@models/Entity'
import type { Page } from '@models/Query'
import type { SearchResults } from '@models/SearchResults'

import { apiClient } from '../../../gateways/api'
import type { Opdracht } from '../../../opdracht/types/Opdracht'

export { fetchOpdrachtenForEntity, initialData }

const initialData = {
  items: [],
  count: 0,
  skip: 0,
  limit: 25,
}

const fetchOpdrachtenForEntity = async ({
  entity: { id },
  page,
}: {
  entity: Entity
  page: Page
}): Promise<SearchResults<Opdracht>> => {
  const { data } = await apiClient({
    url: '/rest/opdracht',
    method: 'POST',
    data: {
      filters: [{ name: 'clusterId', value: id, operator: 'eq' }],
      ...page,
    },
  })

  return data
}
